import { render, staticRenderFns } from "./lotteryhome.vue?vue&type=template&id=56faf9ed&scoped=true&"
import script from "./lotteryhome.vue?vue&type=script&lang=js&"
export * from "./lotteryhome.vue?vue&type=script&lang=js&"
import style0 from "./lotteryhome.vue?vue&type=style&index=0&id=56faf9ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56faf9ed",
  null
  
)

export default component.exports